<svg xmlns="http://www.w3.org/2000/svg" width="112" height="36" viewBox="0 0 112 24">
  <style>
    .dot_base {
      animation: dot_xe7Q 2s linear infinite;
    }
    .dot_1 {
      animation-delay: -1.75s;
    }
    .dot_2 {
      animation-delay: -1.5s;
    }
    .dot_3 {
      animation-delay: -1.25s;
    }
    .dot_4 {
      animation-delay: -1s;
    }
    .dot_5 {
      animation-delay: -0.75s;
    }
    .dot_6 {
      animation-delay: -0.5s;
    }
    .dot_7 {
      animation-delay: -0.25s;
    }


    @keyframes dot_xe7Q {
      93.75%,
      100% {
        r: 4px;
      }
      46.875% {
        r: 0.2px;
      }
    }
  </style>
  <circle class="dot_base" cx="4" cy="12" r="4" />
  <circle class="dot_base dot_1" cx="20" cy="12" r="4" />
  <circle class="dot_base dot_2" cx="36" cy="12" r="4" />
  <circle class="dot_base dot_3" cx="50" cy="12" r="4" />
  <circle class="dot_base dot_4" cx="66" cy="12" r="4" />
  <circle class="dot_base dot_5" cx="82" cy="12" r="4" />
  <circle class="dot_base dot_6" cx="98" cy="12" r="4" />
  <circle class="dot_base dot_7" cx="98" cy="12" r="4" />
</svg>

<style>
  .dot_base {
    fill: #8B54FF;
  }
</style>
